//
import Resposta from '../../shared/entity/Resposta';
import { formatarDinheiro } from '../../shared/helper';
// import CheckBox from '@react-native-community/checkbox';
import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Checkbox, RadioButton } from 'react-native-paper';
import { TXT_M } from '../../constants';
import MiniInputQuantidade from '../Generic/MiniInputQuantidade';
import Touchable from '../Generic/Touchable';

type Props = {
  resposta: Resposta;
  onPress: (resposta: Resposta, quantidade?: number) => boolean;
  adicionado: boolean;
  radio?: boolean;
  esconderValor?: boolean;
};

const ItemResposta: React.FC<Props> = (props) => {
  const { resposta, onPress, adicionado, radio, esconderValor } = props;
  const [quantidade, setQuantidade] = useState(0);

  return (
    <Touchable
      onPress={() => (resposta.maximoItens > 1 ? null : onPress(resposta))}
      style={{
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {radio && (
          <RadioButton
            value=""
            status={adicionado === true ? 'checked' : 'unchecked'}
            onPress={() => onPress(resposta)}
            // onChange={() => onPress(adicional)}
          />
        )}

        {!radio && resposta.maximoItens === 1 && (
          <Checkbox
            // value=""
            status={adicionado === true ? 'checked' : 'unchecked'}
            onPress={() => {
              onPress(resposta);
            }}
            // onChange={() => onPress(adicional)}
          />
        )}

        {!radio && resposta.maximoItens > 1 && (
          <MiniInputQuantidade
            quantidade={quantidade}
            setQuantidade={(quant) => {
              const adicionou = onPress(resposta, quant);
              if (adicionou) {
                setQuantidade(quant);
              }
            }}
            style={{ marginRight: 10 }}
          />
        )}

        <Text style={{ fontSize: TXT_M, fontWeight: '600' }}>{resposta.descricao}</Text>
      </View>

      {esconderValor !== true && (
        <Text style={{ fontSize: TXT_M, fontWeight: '600' }}>
          R${formatarDinheiro(resposta.preco)}
        </Text>
      )}
    </Touchable>
  );
};

const styles = StyleSheet.create({});

export default ItemResposta;
